export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;
export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
export const API_URL = process.env.REACT_APP_API_URI || 'http://localhost:5000/';
export const AUTH0_FOOTHOLD_API_AUDIENCE = process.env.REACT_APP_AUTH0_FOOTHOLD_API_AUDIENCE;
